import axios from "axios";

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '/api';
} else {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL + '/api';
}

axios.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers["Accept"] = "application/json";
      config.headers["X-API-Key"] = process.env.REACT_APP_APIKEY || "";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default axios;
